import { Divider, Grid } from '@material-ui/core';
import BigNumber from 'bignumber.js';
import { OrderDiscountStatus, PaymentClass } from 'generated/graphql';
import { toProperCase } from 'helpers/hooks/stringNumberFunction/stringConverter';
import { amtStr } from 'helpers/numFormatter';
import React from 'react';
import { TaxSchemeComponent } from './TaxSchemeComponent';

export const BillFooterReceipt = (props: any) => {
	const {
		total,
		discount,
		discountCode,
		subtotal,
		serviceCharge,
		tax,
		mode,
		query,
		latestPayment,
		chargeInfo1,
		chargeInfo2,
		currencyCode,
		rounding,
		outletID,
		order,
	} = props;

	const handleCardType = cardType => {
		switch (cardType) {
			case 'VISA_CARD':
				return 'VISA';
			case 'MASTERCARD':
				return 'MASTERCARD';
			case 'AMERICAN_EXPRESS_CARD':
				return 'AMERICAN EXPRESS';
			case 'DINERS_CARD':
				return 'DINERS';
			case 'JCB_CARD':
				return 'JCB';
			case 'UNIONPAY_CARD':
				return 'UNIONPAY';
			case 'DEBIT_CARD':
				return 'DEBIT';
			default:
				return 'Credit';
		}
	};

	const activeOrderDiscount = query[0]?.order?.orderDiscount?.filter(
		y => y?.status === OrderDiscountStatus?.Active,
	)[0];

	const OCENT = discountCode?.filter(
		x => x?.ID === activeOrderDiscount?.discountID,
	)[0]?.discountType;

	const displayOCENT =
		OCENT === 'OFFICER_CHECK'
			? 'Officer Check'
			: OCENT === 'ENTERTAINMENT'
			? 'Entertainment'
			: OCENT === 'DISCOUNT'
			? 'Discount'
			: 'Promo';

	return (
		<>
			<div className="dialog-dynamic-content" style={{ marginTop: '10px' }}>
				<div className="session">
					<div className="flex session">
						<div
							className="flex-space mdDesc"
							style={{
								alignSelf: 'center',
								fontSize: '16px',
								color: '#212121',
							}}
						>
							{'Sub-Total'}
						</div>
						<div
							className="xsTitle rightText"
							style={{ fontSize: '16px', color: '#212121' }}
						>
							{currencyCode + amtStr(subtotal)}
						</div>
					</div>
				</div>
			</div>

			<div className="dialog-dynamic-content">
				<div className="session">
					<div className="flex session">
						<div
							className="flex-space mdDesc"
							style={{
								alignSelf: 'center',
								fontSize: '16px',
								color: '#212121',
							}}
						>
							{`Discount `}
							{query[0]?.order?.orderDiscount?.filter(
								y => y?.status === OrderDiscountStatus?.Active,
							)?.length > 0 &&
								`${
									discountCode?.filter(
										x => x?.ID === activeOrderDiscount?.discountID,
									)[0]?.code
								}`}
						</div>
						<div
							className="xsTitle rightText"
							style={{ fontSize: '16px', color: '#212121' }}
						>
							{`(${currencyCode}${amtStr(discount)})`}
						</div>
					</div>
				</div>
			</div>

			<div className="dialog-dynamic-content">
				<div className="session">
					<div className="flex session">
						<div
							className="flex-space mdDesc"
							style={{
								alignSelf: 'center',
								fontSize: '16px',
								color: '#212121',
							}}
						>
							{'Rounding'}
						</div>
						<div
							className="xsTitle rightText"
							style={{ fontSize: '16px', color: '#212121' }}
						>
							{mode === 'bill-settlement'
								? rounding < 0
									? '(' + currencyCode + Math.abs(rounding).toFixed(2) + ')'
									: currencyCode + amtStr(rounding)
								: latestPayment?.roundingAmount < 0
								? '(' +
								  currencyCode +
								  Math.abs(latestPayment?.roundingAmount).toFixed(2) +
								  ')'
								: currencyCode + amtStr(latestPayment?.roundingAmount)}
						</div>
					</div>
				</div>
			</div>

			<Divider style={{ display: 'flex', width: '100%' }} />

			<div
				className="dialog-dynamic-content"
				style={{ paddingTop: '5px', paddingBottom: '10px' }}
			>
				<div className="session">
					<div className="flex session">
						<div
							className="flex-space xsTitle"
							style={{
								alignSelf: 'center',
								fontSize: '16px',
								paddingBottom: '5px',
								color: '#212121',
							}}
						>
							{'Total'}
						</div>
						<div className="rightText">
							<div
								className={
									mode == 'bill-settlement'
										? 'bill-settlement-number'
										: 'highlight-text'
								}
								style={{
									fontSize: '16px',
									color: '#212121',
									paddingBottom: '5px',
								}}
							>
								{`${currencyCode}${amtStr(
									new BigNumber(Math.abs(total))
										.plus(latestPayment?.roundingAmount ?? 0)
										.toNumber(),
								)}`}
							</div>
						</div>
					</div>
				</div>
			</div>

			<Divider style={{ display: 'flex', width: '100%' }} />

			{/* <div className="dialog-dynamic-content" style={{ marginTop: '10px' }}>
				<div className="session">
					<div className="flex session">
						<div
							className="flex-space mdDesc"
							style={{
								alignSelf: 'center',
								fontSize: '16px',
								color: '#212121',
							}}
						>
							{'Service Charge'}
						</div>
						<div
							className="xsTitle rightText"
							style={{ fontSize: '16px', color: '#212121' }}
						>
							{serviceCharge !== 0 ? currencyCode + amtStr(serviceCharge) : '-'}
						</div>
					</div>
				</div>
			</div>
			<div className="dialog-dynamic-content">
				<div className="session">
					<div className="flex session">
						<div
							className="flex-space mdDesc"
							style={{
								alignSelf: 'center',
								fontSize: '16px',
								color: '#212121',
							}}
						>
							{'SST 6%'}
						</div>
						<div
							className="xsTitle rightText"
							style={{ fontSize: '16px', color: '#212121' }}
						>
							{tax !== 0 ? currencyCode + amtStr(tax) : '-'}
						</div>
					</div>
				</div>
			</div> */}

			<TaxSchemeComponent
				outletID={outletID}
				taxSchemeID={null}
				currencyCode={currencyCode}
				type={'receipt'}
				taxSchemeInfo={order?.taxSchemeInfo}
				taxSchemeFooterInfo={order?.taxSchemeFooterInfo}
				takeaway={false}
				orderID={order?.ID}
			/>

			<Divider style={{ display: 'flex', width: '100%', marginTop: '10px' }} />

			{mode === 'bill-settlement' && (
				<>
					<div
						className="dialog-dynamic-content"
						style={{ paddingBlock: '10px' }}
					>
						<div className="session">
							<div className="flex session">
								<div
									className="flex-space mdDesc"
									style={{ alignSelf: 'center', color: '#212121' }}
								>
									{'Name : ___________________________'}
								</div>
							</div>
						</div>
					</div>
					<div
						className="dialog-dynamic-content"
						style={{ paddingBlock: '10px' }}
					>
						<div className="session">
							<div className="flex session">
								<div
									className="flex-space mdDesc"
									style={{ alignSelf: 'center', color: '#212121' }}
								>
									{'Room/ACC : ________________________'}
								</div>
							</div>
						</div>
					</div>
					<div
						className="dialog-dynamic-content"
						style={{ paddingBlock: '10px' }}
					>
						<div className="session">
							<div className="flex session">
								<div
									className="flex-space mdDesc"
									style={{ alignSelf: 'center', color: '#212121' }}
								>
									{'Signature : _________________________'}
								</div>
							</div>
						</div>
					</div>
				</>
			)}

			{mode == 'void-bill' || mode == 'bill-settlement' ? null : (
				<>
					<div className="dialog-dynamic-content" style={{ marginTop: '5px' }}>
						<div className="session">
							<div className="flex session">
								<div
									className="flex-space xsTitle"
									style={{
										alignSelf: 'center',
										fontSize: '16px',
										color: '#212121',
									}}
								>
									{'Payment'}
								</div>
							</div>
						</div>
					</div>
					<div className="dialog-dynamic-content">
						<div className="session">
							<div className="flex session">
								<div
									className="flex-space mdDesc"
									style={{
										alignSelf: 'center',
										fontSize: '16px',
										color: '#212121',
									}}
								>
									{latestPayment !== undefined
										? latestPayment?.paymentClass === PaymentClass.UnsettledBill
											? 'Unsettled Bill'
											: latestPayment?.paymentClass === PaymentClass.Credit
											? handleCardType(latestPayment?.creditCardType)
											: latestPayment?.paymentClass === PaymentClass.Online
											? 'Online Payment'
											: latestPayment?.paymentClass === PaymentClass.NonGuest
											? 'Non Guest'
											: latestPayment?.paymentClass ===
											  PaymentClass.SuspendFolio
											? 'Suspend Folio'
											: latestPayment?.paymentClass === PaymentClass.BankTt
											? 'Bank TT'
											: toProperCase(latestPayment?.paymentClass)
										: displayOCENT}
								</div>
								<div
									className="xsTitle rightText"
									style={{ fontSize: '16px', color: '#212121' }}
								>
									{latestPayment?.paymentClass === PaymentClass.UnsettledBill
										? currencyCode + amtStr(latestPayment?.amount)
										: currencyCode + amtStr(latestPayment?.receivedAmount)}
								</div>
							</div>
						</div>
					</div>
					{latestPayment?.paymentClass === PaymentClass.Debtor ||
					latestPayment?.paymentClass === PaymentClass.Room ||
					latestPayment?.paymentClass === PaymentClass.NonGuest ||
					latestPayment?.paymentClass === PaymentClass.SuspendFolio ||
					latestPayment?.paymentClass === PaymentClass.Officer ||
					latestPayment?.paymentClass === PaymentClass.Staff ? (
						<div
							className="dialog-dynamic-content"
							style={{ marginBottom: '5px' }}
						>
							<div className="session">
								<div className="flex session">
									<div
										className="mdDesc flex-space"
										style={{
											fontSize: '16px',
											paddingBlock: '2px',
											color: '#212121',
										}}
									>
										<span>{`Charged to `}</span>
										{chargeInfo1 && <span>{`${chargeInfo1} | `}</span>}
										{chargeInfo2 && chargeInfo2?.length <= 25 ? (
											<span
												className="highlight-text"
												style={{ color: '#ff9800' }}
											>
												{`${chargeInfo2}`}
											</span>
										) : (
											<Grid
												item
												xs={12}
												className="highlight-text"
												style={{ color: '#ff9800', marginTop: '5px' }}
											>
												{`${chargeInfo2}`}
											</Grid>
										)}
									</div>
								</div>
							</div>
						</div>
					) : null}

					{latestPayment?.paymentClass === PaymentClass.BankTt ? (
						<div
							className="dialog-dynamic-content"
							style={{ marginBottom: '5px' }}
						>
							<div className="session">
								<div className="flex session">
									<div
										className="mdDesc flex-space"
										style={{
											fontSize: '16px',
											paddingBlock: '2px',
											color: '#212121',
										}}
									>
										<span>{`Remark: `}</span>
										{chargeInfo2 && <span>{`${chargeInfo2}`}</span>}
									</div>
								</div>
							</div>
						</div>
					) : null}

					{latestPayment?.paymentClass === PaymentClass.Voucher ? (
						<div
							className="dialog-dynamic-content"
							style={{ marginBottom: '5px' }}
						>
							<div className="session">
								<div className="flex session">
									<div
										className="flex-space mdDesc"
										style={{
											alignSelf: 'center',
											fontSize: '16px',
											paddingBlock: '2px',
											color: '#212121',
										}}
									>
										Code: {latestPayment?.referenceNo}
									</div>
								</div>
							</div>
						</div>
					) : null}

					{latestPayment?.paymentClass === PaymentClass.Others ? (
						<div
							className="dialog-dynamic-content"
							style={{ marginBottom: '5px' }}
						>
							<div className="session">
								<div className="flex session">
									<div
										className="flex-space mdDesc"
										style={{
											alignSelf: 'center',
											fontSize: '16px',
											paddingBlock: '2px',
											color: '#212121',
										}}
									>
										Remarks: {latestPayment?.referenceNo}
									</div>
								</div>
							</div>
						</div>
					) : null}

					{latestPayment?.paymentClass === PaymentClass.Cash ? (
						<div
							className="dialog-dynamic-content"
							style={{ marginBottom: '5px' }}
						>
							<div className="session">
								<div className="flex session">
									<div
										className="flex-space mdDesc"
										style={{
											alignSelf: 'center',
											fontSize: '16px',
											paddingBlock: '2px',
											color: '#212121',
										}}
									>
										{'Change'}
									</div>
									<div
										className="xsTitle rightText"
										style={{ color: '#212121', fontSize: '16px' }}
									>
										{currencyCode + amtStr(latestPayment?.changeAmount)}
									</div>
								</div>
							</div>
						</div>
					) : null}

					{latestPayment?.paymentClass === PaymentClass.Credit ? (
						<div
							className="dialog-dynamic-content"
							style={{ marginBottom: '5px' }}
						>
							<div className="session">
								<div className="flex session">
									<div
										className="flex-space mdDesc"
										style={{
											alignSelf: 'center',
											fontSize: '16px',
											paddingBlock: '2px',
											color: '#212121',
										}}
									>
										Card ref:{' '}
										{`${`****${latestPayment?.cardNo?.slice(-4)}` ?? '-'}`}
									</div>
								</div>
							</div>
						</div>
					) : null}

					<div
						className="dialog-dynamic-content"
						style={{ marginTop: '30px', marginBottom: '5px' }}
					>
						<div className="session">
							<div className="flex session">
								<div
									className="flex-space xsTitle"
									style={{
										alignSelf: 'center',
										fontSize: '16px',
										color: '#212121',
										textAlign: 'center',
									}}
								>
									{'Thank you. Please come again!'}
								</div>
							</div>
						</div>
					</div>
				</>
			)}
		</>
	);
};
